'use client';

// <DateText value kind />: de enige weergave van een datum of tijd in de UI
// (eigenaarsbesluit 18 oktober 2026). Formaat per oppervlak uit lib/date-format.mjs;
// de hover toont altijd de audit-notatie ('zo 18 okt 2026, 19:16').
//
// De tekst is EEN string in EEN <time>: nooit losse spans per deel in een
// inline-flex, want dan valt de spatie tussen weekdag en dag weg ('di16okt').
// Relatieve soorten (feed, agenda) lopen mee op EEN gedeelde minuuttik.
import { useSyncExternalStore } from 'react';
import { fmtDate, dateTimeAttr } from '@/lib/date-format.mjs';

let _tick = 0;
let _timer = null;
const _subs = new Set();
function subscribe(fn) {
  _subs.add(fn);
  if (!_timer && typeof window !== 'undefined') {
    _timer = window.setInterval(() => { _tick += 1; for (const s of _subs) s(); }, 30000);
  }
  return () => {
    _subs.delete(fn);
    if (!_subs.size && _timer) { window.clearInterval(_timer); _timer = null; }
  };
}
const snap = () => _tick;
const noSub = () => () => {};

export default function DateText({ value, kind = 'cell', lang, time, unit, style, title, empty = '-' }) {
  const live = kind === 'feed' || kind === 'agenda';
  useSyncExternalStore(live ? subscribe : noSub, snap, snap);
  const text = fmtDate(value, kind, { lang, time, unit });
  if (text === '-') return <span style={style}>{empty}</span>;
  return (
    <time
      dateTime={dateTimeAttr(value)}
      title={title ?? fmtDate(value, 'audit', { lang })}
      suppressHydrationWarning
      style={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums', background: 'transparent', ...style }}
    >
      {text}
    </time>
  );
}
